// fix260: a tiny module-level guard so the client-settings tab can tell the
// workspace tab-nav "I have unsaved changes" without lifting the whole settings
// form into a shared context.
//
// ClientSettingsTab registers a checker (is the form dirty?) on mount and clears
// it on unmount. The tab NavLinks call `confirmDiscardIfDirty()` before allowing
// navigation; if the form is dirty, the user is asked to confirm leaving (their
// edits would be lost) and can cancel to go back and Save.

type DirtyChecker = () => boolean;

let dirtyChecker: DirtyChecker | null = null;

export function registerUnsavedGuard(checker: DirtyChecker): void {
  dirtyChecker = checker;
}

export function clearUnsavedGuard(checker: DirtyChecker): void {
  // Only clear if the same checker is still registered (avoids a remounting
  // component clobbering a newer registration).
  if (dirtyChecker === checker) dirtyChecker = null;
}

export function hasUnsavedChanges(): boolean {
  try {
    return dirtyChecker ? dirtyChecker() : false;
  } catch {
    return false;
  }
}

/**
 * Returns true if it's safe to navigate. If there are unsaved changes, asks the
 * user to confirm leaving; returns their choice (true = leave/discard, false =
 * stay).
 */
export function confirmDiscardIfDirty(): boolean {
  if (!hasUnsavedChanges()) return true;
  return window.confirm(
    "You have unsaved changes that will be lost if you leave this tab.\n\n" +
      "Click Cancel to go back and Save, or OK to discard your changes."
  );
}
